// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v3.50.1-0-gdecec92",
    "hash": "gdecec92",
    "distance": 0,
    "tag": "v3.50.1",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v3.50.1",
        "major": 3,
        "minor": 50,
        "patch": 1,
        "prerelease": [],
        "build": [],
        "version": "3.50.1"
    },
    "suffix": "0-gdecec92",
    "semverString": "3.50.1",
    "version": "3.50.1"
};
/* tslint:enable */
